import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { type NumberFormatValues } from 'react-number-format';

import { InvoiceSteps } from 'constants/payment';
import { useValidate } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAmount, setStep } from 'store/payment/slice';
import { Button } from 'views/components/sz/ui/button';
import { Input } from 'views/components/sz/ui/input';

import { SelectAmount } from './select-amount';

const AmountForm = () => {
  const { amount, paymentData } = useAppSelector((state) => state.payment);
  const {
    control,
    handleSubmit,
    formState: { isValid },
    setValue,
  } = useForm({
    mode: 'onChange',
  });
  const dispatch = useAppDispatch();
  const { validateAmount } = useValidate();

  const { maxAmount, minAmount } = useMemo(
    () => ({
      maxAmount: Number(paymentData?.maxAmount),
      minAmount: Number(paymentData?.minAmount),
    }),
    [paymentData],
  );

  const handleChangeAmount = (value: NumberFormatValues) => {
    if (paymentData) {
      setValue('amount', value.value, { shouldValidate: true });
      dispatch(setAmount(value.value));
    }
  };

  const onSubmit = () => {
    dispatch(setStep(InvoiceSteps.ENTER_CARD));
  };

  return paymentData ? (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-6 text-lg leading-5 font-bold bg-white text-sz-black border-b border-b-sz-gray-400">
        Банковской картой
      </div>
      <div className="flex flex-col gap-6 sm:p-6">
        <div className="flex flex-col gap-6 p-4 sm:p-0 bg-white">
          <Controller
            name="amount"
            control={control}
            rules={{
              required: 'Сумма обязательна к заполнению',
              validate: (value) => validateAmount(value, maxAmount, minAmount),
            }}
            render={({ fieldState: { error } }) => (
              <Input
                onValueChange={handleChangeAmount}
                name="amount"
                value={amount}
                label="Сумма"
                inputClassName="w-full"
                placeholder="00.0 KZT"
                amount
                error={error?.message}
              />
            )}
          />
          <SelectAmount />
        </div>

        <div className="px-4 sm:p-0">
          <Button disabled={!isValid} onClick={handleSubmit(onSubmit)}>
            Пополнить
          </Button>
        </div>

        <p className="text-[12px] leading-4 md:text-sm px-4 sm:p-0 font-normal md:leading-5 text-sz-black/60">
          Обращаем ваше внимание, что АО “Сәтті Жұлдыз” не удерживает никаких комиссий!
        </p>
      </div>
    </form>
  ) : null;
};

export { AmountForm };
